import { Typography } from 'antd';

const { Text } = Typography;

export function LKLabel({ children }: { children: React.ReactNode }) {
	return <Text style={{ fontSize: 12 }}>{children}</Text>;
}

export function LKText({ children }: { children: React.ReactNode }) {
	return (
		<Text
			style={{
				fontSize: 12,

				background: 'lightgray',
				appearance: 'none',
				border: 0,
				padding: '2px 4px',
				width: '100%',
				display: 'block',
			}}
		>
			{children}
		</Text>
	);
}
